import React, { FC } from "react";
import { UIFlightSegment } from "@flights/types";
import useAirlineLogos from "../../../../hooks/useAirlineLogos";
import styles from "./FlightCardCarriers.module.css";

type Props = {
  segment: UIFlightSegment;
};

const FlightCardCarriers: FC<Props> = ({ segment }) => {
  const { airlinesWithGridPosition } = useAirlineLogos(segment);

  return (
    <div className={airlinesWithGridPosition.length > 1 ? styles.grid : styles.singleLogo}>
      {airlinesWithGridPosition.map((airline, i) => {
        const { name, logo, cssGridPosition } = airline;

        return (
          <div
            className={airlinesWithGridPosition.length > 1 ? styles.carrierLogo : styles.singleLogo}
            key={i}
            style={{ ...cssGridPosition, backgroundImage: `url(${logo})` }}
            aria-label={name}
          />
        );
      })}
    </div>
  );
};

export default FlightCardCarriers;
